module.exports = __webpack_public_path__ + "static/media/01BD7004-0B69-43DF-A967-62DC1CE1C140.c9289760.JPG";